<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :loading="true"
    :items="videos"
    :pagination.sync="pagination"
    :no-data-text="no_data_text"
    :rows-per-page-text="rows"
    :no-results-text="no_data_text"
    :rows-per-page-items="rows_per_page"
    :total-items="totalItems"
    item-key="id"
    class="elevation-1"
    style="margin: auto;"
  >
      <v-progress-linear :active="loading" slot="progress" color="blue" indeterminate></v-progress-linear>

    <template slot="items" slot-scope="props">
      <tr :active="props.selected" @click="props.selected = !props.selected">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.medias[0].mp4File }}</td>
      </tr>
    </template>
    <template slot="pageText" slot-scope="props">
      Lignes {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
    </template>
  </v-data-table>
</template>

<script>
  import {HTTP} from '../core/http/http-common';
  import Routing from '../core/router/router';
    export default {
      name: "missing-videos",
      props: {
        id: {
          type: String,
          required: true
        },
        type: {
          type: String,
          required: true
        }
      },
      data: () => ({
        selected: [],
        headers: [
          {
            text: 'IDENTIFIANT',
            value: 'id'
          },
          { text: 'DATE CRÉATION', value: 'created_at',sortable: false },
          { text: 'FICHIER VIDÉO', value: 'medias[0].mp4File',sortable: false }
        ],
        videos : [],
        totalItems : 0,
        rows: "Lignes par page",
        rows_per_page: [5, 10, 20, 25, {"text": "Tous", "value": -1}],
        no_data_text: 'Pas de donnée',
        pagination: {
          rowsPerPage: 5
        },
      }),

      watch: {
        pagination: {
          handler(object) {
            this.query.id = this.id;
            this.query.type = this.type;
            this.query.length = object.rowsPerPage;
            this.query.start = object.rowsPerPage * (object.page - 1);
            this.query.columns = [];
            this.query.order = [];
            this.query.order[0] = {};
            this.query.columns[0] = {};
            this.query.columns[0].orderable = true;
            this.query.order[0].column = 0;

            if (object.descending) {
              this.query.order[0].dir = "desc"
            } else {
              this.query.order[0].dir = "asc"
            }
            this.getData();
          },
          deep: true
        }
      },
      methods: {
        getData(){
          this.query.id = this.id;
          this.query.type = this.type;
          this.query.draw++;
          let self= this;
          self.loading = true;
          HTTP.get(Routing.generate("api_dtable_get_missing_videos_rmbox", this.query))
            .then(function(response){

              if(response.data.code === 200){
                self.$nextTick(function(){
                  self.loading = false;
                  self.videos = response.data.data;
                  self.totalItems = response.data.recordsFiltered;
                })
              }
              else{
                self.loading = false;
              }
            },function(error){
              console.log(error)

            })
        }
      },
      created(){
        this.query = {
          length: 5,
          start: 0,
          draw : 0
        };
        this.query.id = '';
        this.query.type = '';
        this.query.columns = [];
        this.query.columns[0] = {};
        this.query.columns[0].orderable = true;
        this.query.order = [];
        this.query.order[0] = {};
        this.query.order[0].column = 0;
        this.query.order[0].dir = 'asc';
        this.query.search = {};
      }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/missingVideos.vue